import script from "./SpendingAnalysisPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpendingAnalysisPage.vue?vue&type=script&setup=true&lang=ts"

import "./SpendingAnalysisPage.vue?vue&type=style&index=0&id=41dfd35c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41dfd35c"]])

export default __exports__